import {
  CODE_BACK_SPACE,
  CODE_DELETE,
  CODE_ENTER,
  CODE_RETURN,
  CODE_SPACE,
  VALUE_BACK_SPACE,
} from 'keycode-js';

const CODES_ALL = new Set([CODE_SPACE, CODE_RETURN, CODE_ENTER]);
const CODES_TYPING = new Set([CODE_RETURN, CODE_ENTER]);

export const isSubmitKey = (code: string, isTyping: boolean = true) => {
  if (isTyping) {
    return CODES_TYPING.has(code);
  }
  return CODES_ALL.has(code);
};

export const isTyping = (): boolean => {
  const tagName = document?.activeElement?.tagName;
  return tagName === 'INPUT' || tagName === 'TEXTAREA';
};

const DELETE_CODES = new Set([CODE_DELETE, CODE_BACK_SPACE]);
// Handle Android return code = "" on delete
export const isDeleteKey = (e: KeyboardEvent) => {
  const { code, key } = e;
  return DELETE_CODES.has(code) || key === VALUE_BACK_SPACE;
};
